export var stakeStates = {
    ACTIVE: 1,
    WON: 2,
    LOST: 3,
    REFUND: 4,
    SOLD: 5,
    REFUND_EXT: 10
};
export var operationTypes = {
    STAKE: 1,
    STAKE_PAYMENT: 2,
    RINGOGAMES_STAKE: 3,
    RINGOGAMES_STAKE_PAYMENT: 4,
    BONUS: 5,
    ACCOUNT_CORRECTION: 6,
    DEPOSIT: 7,
    WITHDRAWAL: 8,
    COMBOBET_STAKE: 9,
    COMBOBET_STAKE_WON: 10,
    BETGAMES_STAKE: 11,
    BETGAMES_STAKE_PAYMENT: 12,
    HOLLYWOOD_TV_STAKE: 13,
    HOLLYWOOD_TV_STAKE_PAYMENT: 14,
    VIVO_STAKE: 15,
    VIVO_STAKE_PAYMENT: 16,
    VIRTUAL_SPORTS: 17,
    VIRTUAL_SPORTS_PAYMENT: 18,
    BETSOLUTIONS_STAKE: 19,
    BETSOLUTIONS_STAKE_PAYMENT: 20,
    TVBET_STAKE: 48,
    TVBET_STAKE_PAYMENT: 49,
    DATABET_STAKE: 5202,
    DATABET_STAKE_PAYMENT: 5302,
    XPRESS_STAKE: 5602,
    XPRESS_STAKE_PAYMENT: 5702,
};



// WEBPACK FOOTER //
// ./src/constants/constants.js